import React from 'react';
import PropTypes from 'prop-types';
import { Button, Card, Dimmer, Table } from 'tabler-react';

const propTypes = {
    invoices: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.array,
    ]),
};

const defaultProps = {
    invoices: {}
};

const InvoicesListCard = (props) => {

    const content = [];

    const invoiceRow = (i, invoice) => {
        return (
            <Table.Row key={i}>
                <Table.Col className="text-nowrap">{invoice.statusDescription}</Table.Col>
                <Table.Col className="text-nowrap">BRL {invoice.amount.toFixed(2)}</Table.Col>
                <Table.Col className="text-nowrap">{invoice.canceled ? 'SIM' : 'NÃO'}</Table.Col>
                <Table.Col className="text-nowrap">{invoice.refunded ? 'SIM' : 'NÃO'}</Table.Col>
                <Table.Col className="w-1 text-nowrap">{invoice.created_at}</Table.Col>
                <Table.Col className="text-right text-nowrap">
                    {/*<Button color="secondary" size="sm">Ver Histórico de Cobranças</Button>*/}
                </Table.Col>
            </Table.Row>
        );
    };

    const buildContent = () => {

        if (props.invoices === null) {
            return;
        }

        Object.keys(props.invoices).forEach((item, i) => {
            content.push(invoiceRow(i, props.invoices[item]));
        });
    };

    buildContent();

    return (
        <React.Fragment>
            <h4 className="mt-4 mb-6 pl-4">Histórico de Faturas</h4>

            <Card>
                <Dimmer loader active={!props.invoices}>
                    <Table cards responsive>
                        <Table.Header>
                            <Table.ColHeader>Status</Table.ColHeader>
                            <Table.ColHeader className="no-wrap">Valor Cobrado</Table.ColHeader>
                            <Table.ColHeader>Cancelada?</Table.ColHeader>
                            <Table.ColHeader>Reembolsada?</Table.ColHeader>
                            <Table.ColHeader noWrap className="w-1">Data</Table.ColHeader>
                            <Table.ColHeader/>
                        </Table.Header>
                        <Table.Body>
                            {content}
                        </Table.Body>
                    </Table>
                </Dimmer>
            </Card>
        </React.Fragment>
    );
};

InvoicesListCard.propTypes = propTypes;
InvoicesListCard.defaultProps = defaultProps;

export default InvoicesListCard;